module.exports = __webpack_public_path__ + "static/media/startupLogo.875e0bbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/StartupNavigation/assets/startupLogo.png
// module id = 543
// module chunks = 0